<template>
    <div class="cart-container page-container">
        <div @click.stop="$router.go(-1)" class="back-to-outfit gray-bottom-border">
            <div class="wtw-container">
                <span class="stay-black">Back</span>
            </div>
        </div>
        <div class="cart-items-container">
            <transition name="fade">
                <div class="no-outfits-message" v-if="cartOutfits.length === 0">No items have been added to cart yet.</div>
            </transition>
            <div class="cart-outfit-container"
                 v-for="(outfitId, index) in cartOutfitsOrdered"
                 :key="outfitId"
            >
                <transition-group name="cart-item">
                    {{ index }}
                    <div class="cart-item"
                         v-for="product in cartProductsOrdered[outfitId]"
                         :key="product.cart_product_id"
                    >
                        <div class="wtw-container small">
                            <div class="cart-info-container"
                                 @click.stop="() => handleItemClick(product)"
                            >
                                <div class="cart-item-image"
                                    :style="{ backgroundImage: 'url(\'' + product.product_image_file + '\')' }">
                                </div>
                                <div class="cart-item-info">
                                    <div v-if="product.product_brand_title" class="brand">{{ product.product_brand_title }}</div>
                                    <div class="title"> {{ product.product_title }}</div>
                                    <div class="title"> {{ productOptionsText(product.product_option_values)  }}</div>
                                    <div class="price"> <span class="inline-title">Price:</span> {{ product.product_price | currency }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="quantity-row wtw-container small">
                            <div class="select-fix small">
                                <select name="quantity" class="small" v-model="product.cart_product_quantity"
                                        @touchstart="focusTarget" @touchend="focusTarget" @change="updateCartProduct(product)">
                                    <option v-for="quantity in quantities" :value="quantity" :key="quantity">
                                        QTY: {{ quantity }}
                                    </option>
                                </select>
                            </div>
                            <img class="remove-item"
                                 :src="imageUrl('remove-item.png')"
                                 @click.stop="deleteProductFromCart(product.cart_product_id, outfitId, product.product_cart_key)"
                            />
                            <div class="subtotal"> <span class="inline-title">Subtotal:</span> {{ getRowTotal(product) | currency }}</div>
                        </div>
                        <div class="cart-item-error" v-bind:class="checkItemErrorDisplay(product)">
                            <span>We are sorry but this item is currently unavailable</span>
                            <swap-item-button
                                classes="button pink swap-button"
                                text="SWAP"
                                icon="white"
                                @click="() => setSwapProduct(product, outfitId, product.product_cart_key)"
                            />
                        </div>
                    </div>
                </transition-group>
            </div>
        </div>
        <div class="text-center checkout faux-fixed">
            <div class="cart-total">Order total: {{ cartTotal | currency }}</div>
            <div class="button pink full-width"
                 @click.stop="checkout" v-bind:class="validateCheckoutButton()">
                Checkout
            </div>
        </div>

        <transition name="fade">
            <swap-item
                v-if="showSwapProduct"
                :product="currentSwapProduct"
                :showSizes="true"
                :swapCb="swapProduct"
                @close="() => this.showSwapProduct = false"
            />
        </transition>
    </div>
</template>

<script>
    import SwapItemButton from '../products/swap-item-button.vue';
    import SwapItem from '../products/swap-item.vue';

    import Mixins from'../../mixins/mixins.js';
    import {mapGetters} from 'vuex';
    import $ from 'webpack-zepto';
    import gql from 'graphql-tag';
    import {_} from "vue-underscore";
    import { OUTFIT_TYPES } from '../../config.js';
    
    export default {
        data() {
            return {
                quantities: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                showSwapProduct: false,
                currentSwapProduct: null,
            }
        },
        mixins: [Mixins],
        components: {
            SwapItemButton,
            SwapItem,
        },
        methods: {
            checkout() {
                if(this.checkoutProvider == 'stripe') {
                    this.$router.push({path: '/checkout/stripe'});
                    return;
                }
                this.$router.push({path: '/checkout'});
            },
            deleteProductFromCart(id, outfitId, productKey){

                // Deleting from state and praying that no errors return from api call. This is to remove delay from API call to updating state.

                this.$store.commit({
                    type: 'cart/deleteProductFromCart',
                    outfitId,
                    productKey
                });

                this.$store.dispatch({
                    type: 'cart/deleteProductFromCart',
                    id
                })
            },
            updateCartProduct(product){

                this.$store.dispatch({
                    type: 'cart/updateCartProduct',
                    product: product,
                    user: this.user
                })
            },
            fetchProduct() {
                this.dataLoaded = false;
            },
            selectWidth(product){

                /* Elongate select width based on string length -- TO DO: update with min-width in css */

                let stringLengths = product.product_sizes.map(size => size.product_option_value_title);

                if(stringLengths.length > 0) {
                    let longest = stringLengths.reduce(function (a, b) {
                        return a.length > b.length ? a : b;
                    });
                    let newLength = longest.length * 9;
                    return newLength > 75 ? newLength : 75;

                } else {
                    return 75;
                }
            },
            getRowTotal(product) {
                return product.product_price * product.cart_product_quantity;
            },
            setCartReturnPage() {
                this.$store.commit('menu/setReturnPage', {title: 'Back to Cart', href: '/cart'})
            },
            validateCheckoutButton() {
                var cartOutfits = this.cartOutfits;

                let canCheckout = true;
                _.each(cartOutfits, outfit => {
                    _.each(outfit, cartProduct => {
                        if(this.checkoutProvider == 'shopify') {
                            if(typeof cartProduct.variant_shopify_id === 'undefined' || !cartProduct.variant_shopify_id) {
                                canCheckout = false;
                            }
                        }
                    });
                });

                return canCheckout && this.cartProductsCount > 0 ? [] : ['disabled'];
            },
            checkItemErrorDisplay(product) {
                if(product.qty <= 0 || product.in_stock == 0) {
                    return ['visible'];
                } else if(this.checkoutProvider == 'shopify') {
                    return (!!product.variant_shopify_id) ? [] : ['visible'];
                }
                return [];
            },
            productOptionsText(options) {
                if(options) {
                    const color = options.find(option => option.product_option_token === 'color');
                    const size = options.find(option => option.product_option_token === 'size');
                    
                    if(size) {
                        return `${size.product_option_value_title} ${color && `- ${color.product_option_value_title}` || ''}`
                    }
                }                
            },
            handleItemClick(product, outfitId) {
                this.setCartReturnPage();
                this.$helpers.visitProduct(
                    this.$router,
                    product,
                    {
                        productOptionValueId: product.product_option_value_id,
                        productOptionSizeValueId: product.product_option_value_id_size,
                        outfitId: product.outfit_id,
                        outfitType: OUTFIT_TYPES.CART
                    }
                );
            },
            setSwapProduct(product, outfitId, cartProductKey) {
                this.showSwapProduct = true;
                this.currentSwapProduct = {
                    ...product,
                    outfit_id: outfitId,
                    cart_product_key: cartProductKey,
                };

                this.$helpers.trackEvent("swap_init", {});
            },
            swapProduct(newProduct) {
                const { cart_product_id, outfit_id, cart_product_key } = this.currentSwapProduct;
                
                return this.$store
                    .dispatch({
                        type: "cart/insertProductsToCart",
                        products: [
                            {
                                ...newProduct,
                                outfit_id,
                                selected: true,
                            },
                        ],
                    }).then(() => this.deleteProductFromCart(cart_product_id, outfit_id, cart_product_key));
            },
        },
        computed: {
            ...mapGetters({
                cartProducts: 'cart/getCartProducts',
                cartOutfits: 'cart/getCartOutfits',
                cartProductsCount: 'cart/cartProductsCount',
                cartTotal: 'cart/getCartTotal',
                checkoutProvider: 'cart/getCheckoutProvider',
                customerToken: 'auth/getCustomerToken',
                user: "auth/getUser",
                returnPage: "menu/returnPage",
            }),
            cartOutfitsOrdered() {
                return Object.keys(this.cartOutfits).sort((a, b) => {
                    if (this.cartOutfits[a]['date'] === this.cartOutfits[b]['date']) {
					    return 0;
				    }
				    return (this.cartOutfits[a]['date'] > this.cartOutfits[b]['date']) ? -1 : 1;
                });
            },
            cartProductsOrdered() {
                const cartOutfits = {};
                Object.keys(this.cartOutfits).forEach(id => {
                    cartOutfits[id] = {};
                    Object.assign(cartOutfits[id], this.cartOutfits[id]);
                    cartOutfits[id] = Object.keys(cartOutfits[id])
                        .map(productKey => {
                            return {
                                ...cartOutfits[id][productKey],
                                product_cart_key: productKey,
                            };
                        })
                        .sort((a, b) => {
                            if (a['cart_product_timestamp_updated'] === b['cart_product_timestamp_updated']) {
                                return 0;
                            }
                            return (a['cart_product_timestamp_updated'] > b['cart_product_timestamp_updated']) ? -1 : 1;
                        });
                    delete cartOutfits[id]['date'];
                });

                return cartOutfits;
            },
        },
        mounted() {
            this.$store.commit({
                type: 'footer/hideFooter'
            });
        },
        beforeDestroy() {
            this.$store.commit({
                type: 'footer/showFooter'
            });
        }
    }
</script>

<style lang="scss" scoped>
    .no-outfits-message {
        position: absolute;
        top: calc(50% - 40px);
        width: 70%;
        left: 15%;
        font-size: 20px;
        text-align: center;
        font-weight: 300;
    }
</style>